<template>
  <div class="Xrow">
    <p class="quill-question-placeholder">{{
        forcePromptPlaceholder ? question.prompt : question.placeholder
      }}</p>
    <p class="content">
      {{ mask ? maskDate(value) : value }}
    </p>

  </div>
</template>

<script>
import {Mask} from 'maska2'

export default {
  name: 'ReadOnly',
  props: ['question', 'forcePromptPlaceholder', 'value', 'mask'],
  methods: {
    maskDate(val) {
      const m = new Mask({mask: this.mask})
      return m.masked(val)
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
  color: #212121;
  padding: 0 8px;
}

.subtext {
  font-size: .75rem;
  font: normal normal normal 12px/18px Roboto;
  letter-spacing: 0px;
  margin-bottom: 4px;
  color: #757575
}

.errorMessage {
  color: #BB0000
}

.gap {
  margin-right: 10px;
}

.quill-question {
  > div {
    position: relative;
    min-height: 50px;
    cursor: initial !important;


    .quill-question-placeholder {
      //position: absolute;
      padding: 0;
      margin: 0;
      line-height: 2em;
      top: 0;
      left: 0;
      color: #757575;
      font-size: 14px;
      pointer-events: none;
      transform: scale(1);
      transition: .26s all ease;
    }


  }

}

/*TODO convert to scss*/

.quill-question > label > i > svg:hover:hover ~ span {
  visibility: visible;
  transition-delay: .31s;
}

.quill-question > div .quill-question-input:focus,
.quill-question > div .quill-question-input:not(.radio,:placeholder-shown) {
  padding: 25px 8px 5px 16px;
}

.quill-question > div .quill-question-placeholder, div .quill-question-placeholder {
  font-size: 12px;
  padding: 0 8px 2px;
}

.quill-question > div .quill-question-input:focus ~ ul {
  /*display: block;*/
  visibility: visible;
  transition-delay: 0.1s;
}


</style>